import { Content, ContentIconFields } from '@beat-venues/common-types';

export const mockContentIconBase: Content<'contentIcon', ContentIconFields> = {
    sys: {
        id: '6winRgszgbsg87jY13EgdO',
        contentType: {
            sys: {
                id: 'contentIcon',
            },
        },
    },
    fields: {
        iconName: 'GroupDottedIcon',
    },
};
